import Modbury51 from '../Modbury 5/Tipe 5 (1).webp'
import Modbury52 from '../Modbury 5/Tipe 5 (2).webp'


const Modbury5images =[
Modbury51,Modbury52
]

export default Modbury5images;